import { FormBuilder, FormControl } from "@angular/forms";
import { FormComponent } from "@mctic/ng-core";

export class InfoEntidadeForm extends FormComponent<any> {

    constructor(protected readonly fb: FormBuilder) {
        super(
            fb.group({
                cnpj: new FormControl({ value: null, disabled: true }),
                razaoSocial: new FormControl({ value: '', disabled: true }),
            })
        );
    }

    get cnpj() {
        return this.formGroup.get('cnpj').value;
    }

    get razaoSocial() {
        return this.formGroup.get('razaoSocial').value;
    }

    setarEntidadeSelecionada({ cnpj, razaoSocial }) {
        this.formGroup.patchValue({
            cnpj,
            razaoSocial
        });
    }

}